var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import LocalStorageUtils from '../utils/LocalStorageUtils';
var CONFIG_STORAGE_KEY = 'sct_widget_client_config';
var CONFIG_EXPIRY = 24 * 60 * 60 * 1000; // 24 hours
var ConfigService = /** @class */ (function () {
    function ConfigService() {
        this.config = null;
    }
    ConfigService.getInstance = function () {
        if (!ConfigService.instance) {
            ConfigService.instance = new ConfigService();
        }
        return ConfigService.instance;
    };
    ConfigService.prototype.initialize = function () {
        return __awaiter(this, arguments, void 0, function (forceRefresh) {
            var cachedConfig;
            if (forceRefresh === void 0) { forceRefresh = false; }
            return __generator(this, function (_a) {
                // If force refresh, bypass cache
                if (forceRefresh) {
                    return [2 /*return*/, this.fetchConfig()];
                }
                cachedConfig = LocalStorageUtils.getItem(CONFIG_STORAGE_KEY);
                if (cachedConfig) {
                    this.config = cachedConfig;
                    return [2 /*return*/, cachedConfig];
                }
                // If no cached config, fetch from API
                return [2 /*return*/, this.fetchConfig()];
            });
        });
    };
    ConfigService.prototype.fetchConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var config;
            return __generator(this, function (_a) {
                config = {};
                config.defaultLanguage = config.defaultLanguage || 'en';
                config.isPushToTalk = config.isPushToTalk || true;
                // Cache the config
                LocalStorageUtils.setItem(CONFIG_STORAGE_KEY, config, CONFIG_EXPIRY);
                this.config = config;
                return [2 /*return*/, config];
            });
        });
    };
    ConfigService.prototype.getConfig = function () {
        return this.config;
    };
    ConfigService.prototype.clearConfig = function () {
        LocalStorageUtils.removeItem(CONFIG_STORAGE_KEY);
        this.config = null;
    };
    return ConfigService;
}());
export default ConfigService.getInstance();
